class VendorController {
  /* @ngInject */
  constructor($http, $stateParams, $state) {
    this.$http = $http;
    this.$stateParams = $stateParams;
    this.$state = $state;
  }

  $onInit() {
    this.getVendors();
  }

  getVendors() {
    this.$http.get('/clientVendor')
      .then(({ data }) => (this.vendors = data));
  }

  skip() {
    this.$state.go('main.cases.fill', { id: this.$stateParams.id });
  }

  submit(form) {
    if (form.$invalid || this.submitting) return;

    this.submitting = true;
    this.$http.put(`/case/${this.$stateParams.id}/allocate`, { vendorId: this.selectedVendor })
      .then(() => {
        this.submitting = false;
        this.$state.go('main.cases.fill', { id: this.$stateParams.id });
      })
      .catch(() => (this.submitting = false));
  }
}

export default VendorController;



// WEBPACK FOOTER //
// ./client/app/cases/vendor/vendor.controller.js